/* ==========================================================================
   Snarky Organs — Interactions
   Typewriter hero, glow cursor, scroll effects, Easter eggs
   ========================================================================== */

(function() {
  'use strict';

  /* --- Glow Stick Cursor (Desktop Only) --- */
  function initGlowCursor() {
    if (window.matchMedia('(pointer: coarse)').matches) return;
    if (window.innerWidth < 990) return;
    if (document.querySelector('.snarky-glow-cursor')) return;

    var cursor = document.createElement('div');
    cursor.classList.add('snarky-glow-cursor');
    document.body.appendChild(cursor);

    var mouseX = -200, mouseY = -200;
    var cursorX = -200, cursorY = -200;

    document.addEventListener('mousemove', function(e) {
      mouseX = e.clientX;
      mouseY = e.clientY;
    });

    function animate() {
      cursorX += (mouseX - cursorX) * 0.15;
      cursorY += (mouseY - cursorY) * 0.15;
      cursor.style.left = cursorX + 'px';
      cursor.style.top = cursorY + 'px';
      requestAnimationFrame(animate);
    }
    animate();
  }

  /* --- Staggered Scroll Entrance for Product Cards --- */
  function initScrollEntrance() {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var cards = entry.target.querySelectorAll('.card-wrapper');
          cards.forEach(function(card, i) {
            card.classList.add('snarky-stagger-enter');
            setTimeout(function() {
              card.classList.add('snarky-visible');
            }, i * 80);
          });
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    document.querySelectorAll('.collection-product-list, .grid--2-col-tablet-down').forEach(function(grid) {
      observer.observe(grid);
    });
  }

  /* --- Section Fade-Up on Scroll --- */
  function initSectionFadeUp() {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('snarky-section-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.05 });

    document.querySelectorAll('section.section, .shopify-section').forEach(function(section) {
      // Don't animate the header or hero
      if (section.classList.contains('section-header')) return;
      if (section.classList.contains('snarky-hero-section')) return;
      section.classList.add('snarky-section-enter');
      observer.observe(section);
    });
  }

  /* --- Logo Heartbeat --- */
  function initLogoHeartbeat() {
    var logo = document.querySelector('.header__heading-logo-wrapper, .header__heading-link');
    if (!logo) return;

    setInterval(function() {
      logo.classList.add('snarky-heartbeat');
      setTimeout(function() {
        logo.classList.remove('snarky-heartbeat');
      }, 600);
    }, 4000);
  }

  /* --- Code Blue Easter Egg (5x logo click) --- */
  function initCodeBlue() {
    var logo = document.querySelector('.header__heading-link');
    if (!logo) return;

    var clickCount = 0;
    var clickTimer = null;

    logo.addEventListener('click', function(e) {
      clickCount++;
      e.preventDefault();
      clearTimeout(clickTimer);

      if (clickCount >= 5) {
        clickCount = 0;

        // Flash blue
        var flash = document.createElement('div');
        flash.classList.add('snarky-code-blue-flash');
        document.body.appendChild(flash);
        setTimeout(function() { flash.remove(); }, 600);

        // Show toast
        var toast = document.createElement('div');
        toast.classList.add('snarky-toast');
        toast.innerHTML = 'CODE BLUE! 15% off with code <strong>CODEBLUE</strong>';
        document.body.appendChild(toast);
        setTimeout(function() { toast.classList.add('snarky-toast--visible'); }, 50);
        setTimeout(function() {
          toast.classList.remove('snarky-toast--visible');
          setTimeout(function() { toast.remove(); }, 300);
        }, 5000);
        return;
      }

      // Navigate to homepage if fewer than 5 clicks in window
      clickTimer = setTimeout(function() {
        clickCount = 0;
        window.location.href = logo.href;
      }, 1500);
    });
  }

  /* --- Hero Typewriter --- */
  function initTypewriter() {
    var heroes = document.querySelectorAll('[id^="HeroTypewriter-"]');
    heroes.forEach(function(hero) {
      var textEl = hero.querySelector('[id^="TypewriterText-"]');
      var lineEl = textEl ? textEl.closest('.snarky-hero-typewriter__line') : null;
      var slides = hero.querySelectorAll('.snarky-hero-typewriter__slide');
      if (!textEl || !lineEl || slides.length === 0) return;

      var speed = parseInt(hero.dataset.speed) || 60;
      var pause = parseInt(hero.dataset.pause) || 2000;
      var currentSlide = 0;

      function typeText(text, callback) {
        var i = 0;
        textEl.textContent = '';
        var interval = setInterval(function() {
          textEl.textContent += text.charAt(i);
          i++;
          if (i >= text.length) {
            clearInterval(interval);
            if (callback) callback();
          }
        }, speed);
      }

      function deleteText(callback) {
        var text = textEl.textContent;
        var i = text.length;
        var interval = setInterval(function() {
          i--;
          textEl.textContent = text.substring(0, i);
          if (i <= 0) {
            clearInterval(interval);
            if (callback) callback();
          }
        }, speed / 2);
      }

      function showSlide(index) {
        slides.forEach(function(s) {
          s.style.display = 'none';
          s.classList.remove('snarky-active');
        });
        slides[index].style.display = '';
        slides[index].classList.add('snarky-active');
      }

      function hideSlide() {
        slides.forEach(function(s) {
          s.style.display = 'none';
          s.classList.remove('snarky-active');
        });
      }

      function runCycle() {
        var slide = slides[currentSlide];
        var problem = slide.dataset.problem;
        var solution = slide.dataset.solution;

        lineEl.classList.remove('snarky-solution');
        hideSlide();

        typeText(problem, function() {
          setTimeout(function() {
            deleteText(function() {
              lineEl.classList.add('snarky-solution');
              showSlide(currentSlide);
              typeText(solution, function() {
                setTimeout(function() {
                  currentSlide = (currentSlide + 1) % slides.length;
                  runCycle();
                }, pause + 1000);
              });
            });
          }, pause);
        });
      }

      runCycle();
    });
  }

  /* --- Flatline Footer Transition --- */
  function initFlatline() {
    var flatline = document.querySelector('.snarky-flatline');
    var todEl = document.getElementById('snarky-tod');
    if (!flatline) return;

    // Set time of death to current local time
    if (todEl) {
      var now = new Date();
      todEl.textContent = now.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    }

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          flatline.classList.add('snarky-flatline--visible');
          // After EKG line draws (2s), go flat
          setTimeout(function() {
            flatline.classList.add('snarky-flatline--flat');
          }, 2200);
          observer.unobserve(flatline);
        }
      });
    }, { threshold: 0.3 });

    observer.observe(flatline);
  }

  /* --- Doctor's Notes Margin Scribbles --- */
  function initScribbles() {
    if (window.innerWidth < 1200) return;

    var scribbles = [
      { selector: '.featured-collection:first-of-type', text: 'Nurse approved', position: 'right' },
      { selector: '.newsletter', text: 'Shift change updates', position: 'left' },
      { selector: '.multicolumn', text: 'The fine print', position: 'right' }
    ];

    scribbles.forEach(function(config) {
      var target = document.querySelector(config.selector);
      if (!target) return;

      target.style.position = 'relative';

      var note = document.createElement('span');
      note.classList.add('snarky-scribble');
      note.textContent = config.text;

      if (config.position === 'right') {
        note.style.right = '-80px';
        note.style.top = '40px';
        note.style.transform = 'rotate(3deg)';
      } else {
        note.style.left = '-80px';
        note.style.top = '40px';
        note.style.transform = 'rotate(-2deg)';
      }

      target.appendChild(note);

      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            note.classList.add('snarky-scribble--visible');
            observer.unobserve(target);
          }
        });
      }, { threshold: 0.3 });

      observer.observe(target);
    });
  }

  /* --- Add to Cart Liquid Fill Effect --- */
  function initAddToCartFill() {
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.quick-add__submit');
      if (!btn || btn.disabled) return;

      btn.classList.add('snarky-filling');
      setTimeout(function() {
        btn.classList.remove('snarky-filling');
      }, 800);
    });
  }

  /* --- Init All Interactions --- */
  function init() {
    // Add JS-ready class so CSS animations only apply when JS is available
    document.body.classList.add('snarky-js-ready');

    // Skip animations for users who prefer reduced motion
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!reducedMotion) initGlowCursor();
    if (!reducedMotion) initScrollEntrance();
    if (!reducedMotion) initSectionFadeUp();
    initLogoHeartbeat();
    initCodeBlue();
    initTypewriter();
    initFlatline();
    initScribbles();
    initAddToCartFill();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
